export const FAQDataTypeEnum = {
    SECTION: 'section',
    ITEM: 'item',
};
